import React from "react";
import { useContent } from '../contexts/ContentContext';
import '../assets/styles/EducationJourney.scss';

function EducationJourney() {
  const { content } = useContent();
  const education = content.educationJourney;

  return (
    <div className="education-journey-container" id="education-journey">
      <div className="items-container">
        <div className="section-code-header">
          <span className="code-keyword">const</span>
          <span className="code-variable">educationJourney</span>
          <span className="code-operator">=</span>
          <span className="code-bracket">[</span>
        </div>
        <p className="section-comment">// Academic milestones and growth in AI / engineering</p>
        <div className="education-grid">
          {education.map((edu, index) => (
            <div key={index} className="education-card">
              <div className="education-header">
                <h3 className="education-degree">{edu.degree} in {edu.field}</h3>
                <span className="education-institution">{edu.institution}</span>
              </div>
              <span className="education-year">{edu.year}</span>
              <p className="education-details">{edu.details}</p>
              <div className="education-code-line">
                <span className="code-token">@focus</span> <span>{edu.degree.split(' ')[0]} aligned with real-world projects</span>
              </div>
            </div>
          ))}
        </div>
        <div className="section-code-footer">];</div>
      </div>
    </div>
  );
}

export default EducationJourney;